import { ChangeDetectorRef,Component, Input, OnInit,
Output,EventEmitter,ViewRef } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'

import {
	Observable,
	BehaviorSubject,	
} from "rxjs";
import { Subject } from 'rxjs/internal/Subject'

import { debounceTime, first } from 'rxjs/operators'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'

import {FormControl } from '@angular/forms'

import {  TiersService
 } from '../../../../../services'
 
const KEY = 'user'

@Component({
  selector: 'atyl-user-search-list',
  templateUrl: './user-search.component.html',
  styleUrls: ['./user-search.component.scss']
})
@Stringable({
  path: 'views/partials/content/general/user-search',
  key: KEY,
})
export class UserSearchListComponent implements OnInit {

  expanded: boolean = false;
 
  
  @StringableValues(KEY) strings: any
  
    @Input() users: any[] = [];
   @Input() professionel: boolean=true;
  @Input() tiersInput: any;
   @Output() onUserSelected = new EventEmitter<any>();
   @Input() loading:Observable<boolean>;
   @Input() disabled: boolean=false;
   
   tiersListGroupe: any = [];
    tiersListAutres: any = [];
	
	@Output() onListGroupSelected = new EventEmitter<any[]>();
	
    Moi: any = [];
    
    private debounce: Subject<string> = new Subject();
    
    inputSearch: FormControl = new FormControl();
    
  //   @Input() loading: any[] = [];
  constructor(
	  private tiersService: TiersService,
	  private changeDetectorRef: ChangeDetectorRef,
  ) { }

  ngOnInit() {
	  //console.log('UserSearchListComponent init',this.loading,this.disabled);
	this.loading.subscribe((status:any)=>{
				console.log('UserSearchListComponent init status',status);
				if (status)
					this.loadTiersList();
	})		
     /* this.loading.subscribe((status:any)=>{
				console.log('UserSearchListComponent init status',status);
				if (status)*/
		//	 		this.loadTiersList();
	//		})
  }
  detectChanges() {
  	    //    setTimeout(() => {
  	            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
  	                this.changeDetectorRef.detectChanges()
  	            }
  	    //    })
  }
  
  loadTiersList() {
        
        
        
      //  console.log("UserSearchListComponent loadTiersList",this.tiersInput,this.disabled)
        
        
        this.tiersService.list("", ["PMI", "ADMIN"],true).subscribe((res) => {
            let tiersList = res.result;
            tiersList.forEach(element => {
                if(element['sector'] == 1){
                    this.tiersListGroupe.push(element);
                }else if(element['sector'] == 0){
                    this.tiersListAutres.push(element);

                }else{
                    this.Moi=element;
                    if (this.tiersInput==undefined)
                    	this.tiersInput=element.ID;
                    this.onUserSelected.emit(this.tiersInput);
                   	this.inputSearch.setValue(this.tiersInput);
                }
            });
			this.onListGroupSelected.emit( this.tiersListGroupe);
			
         //   console.log('tiersList:',tiersList);
         //   console.log('Moi:', this.Moi);
          //  console.log('List group', this.tiersListGroupe,this.tiersListAutres);
          //   console.log('tiersInput', this.tiersInput);
          //  this.changeDetectorRef.detectChanges();
		  this.detectChanges();
            
            this.debounce.pipe(debounceTime(1000)).subscribe((search) => {
			//if (search.length > 0)
			 {
				this.tiersService
					.list(search, ["PMI", "ADMIN"])
					.subscribe((result: JSONRpcResponse) => {
						 let tiersList = result.result;
			            this.tiersListAutres=[];
			            this.tiersListGroupe=[];
			            tiersList.forEach(element => {
			                if(element['sector'] == 1){
			                    this.tiersListGroupe.push(element);
			                }else if(element['sector'] == 0){
			                    this.tiersListAutres.push(element);
			
			                }else{
			                    this.Moi=element;
			                  //  this.tiersInput=element.ID;
			                  
			                }
			            });
						this.onListGroupSelected.emit( this.tiersListGroupe);
						
			       //     console.log('tiersList:',tiersList);
			      //      console.log('Moi:', this.Moi);
			      //      console.log('tiersInput', this.tiersInput);
			           this.inputSearch.setValue(this.tiersInput);
			        //    this.changeDetectorRef.detectChanges();
							this.detectChanges();
					
					})
					}
				})
            
        })
        
    }
    
    userSelected(event:any) {
		//console.log("userSelected",event);
		if(event && event!=null){
			this.onUserSelected.emit(this.tiersInput);
		}

	}
	
	triggerAutocompUserList(search: any) {
		this.debounce.next(search)
	}
	
  	displayAutoUserList(key?: any){
		// console.log("displayAutoUserList",key,this.tiersListAutres,this.tiersListGroupe,this.Moi);
  	//: string | undefined
  	 
  	   	let selected:any
  	    if (this.tiersListAutres || this.tiersListGroupe || this.Moi) {
			this.tiersListGroupe.forEach((select) => {
				if (select.ID === key) selected = select
			})
			this.tiersListAutres.forEach((select) => {
				if (select.ID === key) selected = select
			})
			if (this.Moi.ID==key)
			  selected =this.Moi;
			
		}
		
		
		
		// console.log("displayAutoUserList after",selected);
		  
		  let label:string="";
		  if (selected) {
			 if (selected.nom!=undefined)
			   label+=selected.nom.toUpperCase();
			 if (selected.prenom!=undefined)
			   label+=" "+ selected.prenom.toUpperCase(); 
			  
		  }
		  
  	    return selected ? label : undefined;
		/*let selected
		if (this.autocompSelectList) {
			this.autocompSelectList.forEach((select) => {
				if (select.key === key) selected = select
			})
		}
		return selected ? selected.value : undefined
		*/
	}

}